/* One row open at a time.
   Dawn's rows are plain <details>, which open independently, so the list grew
   into a wall once a few were opened.

   The listener is bound to each <details> rather than to the document: the
   toggle event does not propagate here, so a delegated listener on document
   never fires, capture phase included. Verified by counting.

   Focus is dropped on close too, otherwise the summary keeps its focus ring
   and the row still reads as active after it has shut. */
(function () {
  function siblings(d) {
    var scope = d.closest('.shopify-section') || document;
    return Array.prototype.filter.call(
      scope.querySelectorAll('details'),
      function (o) { return o !== d && o.querySelector('.accordion__title'); }
    );
  }

  function bind(d) {
    if (d.dataset.uvAccordion) return;
    d.dataset.uvAccordion = '1';
    d.addEventListener('toggle', function () {
      if (d.open) {
        siblings(d).forEach(function (o) { if (o.open) o.open = false; });
      } else {
        var s = d.querySelector('summary');
        if (s && document.activeElement === s) s.blur();
      }
    });
  }

  function boot() {
    document.querySelectorAll('details').forEach(function (d) {
      if (d.querySelector('.accordion__title')) bind(d);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
